import type { Project } from '../types'

type ProjectImages = Pick<Project, 'image' | 'gallery' | 'showcaseImages'>

function cleanImages(images: Array<string | undefined>) {
  return [...new Set(images.map((image) => image?.trim()).filter((image): image is string => Boolean(image)))]
}

function resolveStoredImage(reference: string | undefined, project: ProjectImages) {
  const value = reference?.trim() || ''
  if (value === '@cover') return project.image?.trim() || ''
  const galleryMatch = value.match(/^@gallery:(\d+)$/)
  if (galleryMatch) return project.gallery?.[Number(galleryMatch[1])]?.trim() || ''
  return value
}

export function projectShowcaseImages(project: ProjectImages, displayIndex = 0): [string, string] {
  const gallery = cleanImages(project.gallery || [])
  const selected = (project.showcaseImages || [])
    .slice(0, 2)
    .map((image) => resolveStoredImage(image, project))
  const primary = selected[0] || project.image?.trim() || gallery[0] || ''
  const automaticSecondary = gallery[displayIndex === 1 ? 2 : 3]
    || gallery.find((image) => image !== primary)
    || primary

  return [primary, selected[1] || automaticSecondary]
}

export function projectImageOptions(project: ProjectImages) {
  const selected = projectShowcaseImages(project)
  return cleanImages([
    project.image,
    ...(project.gallery || []),
    ...selected,
  ])
}

export function serializeProjectShowcaseImages(project: ProjectImages) {
  const gallery = project.gallery || []
  return projectShowcaseImages(project).map((image) => {
    if (image === project.image?.trim()) return '@cover'
    const galleryIndex = gallery.findIndex((candidate) => candidate.trim() === image)
    return galleryIndex >= 0 ? `@gallery:${galleryIndex}` : image
  })
}
